import { ButtonHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';

export const StyledCloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border: 1px solid rgba(148, 163, 184, 0.24);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.88);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    color: #475569;
    cursor: pointer;
    backdrop-filter: blur(10px);
    transition:
        background 0.2s ease,
        border-color 0.2s ease,
        box-shadow 0.2s ease,
        transform 0.2s ease;

    &:hover {
        background: #ffffff;
        border-color: rgba(131, 83, 226, 0.32);
        box-shadow: 0 14px 28px rgba(131, 83, 226, 0.14);
        transform: translateY(-1px);
    }

    svg {
        font-size: 18px;
    }
`;

type ModalCloseButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
    ariaLabel?: string;
};

export const ModalCloseButton = ({
    ariaLabel = 'Close',
    type = 'button',
    ...rest
}: ModalCloseButtonProps) => (
    <StyledCloseButton type={type} aria-label={ariaLabel} {...rest}>
        <Close />
    </StyledCloseButton>
);

export default ModalCloseButton;
